import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase, momentDate
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import {Select, message, Tooltip, Skeleton, Space, Drawer, Spin} from 'antd';

import PsContext from '../../context/PsContext';

const Option = {Select};

const styles = {
	paper: {
		backgroundColor: '#fff',
		padding: '10px',
	},
	trHeader: {
		backgroundColor: '#efefef',
		padding: '5px',
	},
	tdSingleTopBr: {
		borderTop: '1px solid black',
		borderBottom: '1px double black',
		fontWeight: 'bold',
	},
	tdDoubleTopBr: {
		borderTop: '1px solid double black',
	},
	txtNoBorder: {
		border: 'none',
		width: '80px',
		marginTop: '5px',
		marginBottom: '5px',
	}
}

class NewPayment extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
			customers: [],
			selectedCustomer: [],
			dataList: [],
			dataView: [],
			i__advance: 0,
			i__add: 0,
			i__totalAdvance: 0,
			i__lastPaid: 0,
			i__currentDeduction: 0,
			i__balance: 0,
			i__cashInHand: 0,
		}
		
		this.handleCustomerChange = this.handleCustomerChange.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.handleReset = this.handleReset.bind(this);
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Payments',
			back: true,
			to: '/app',
		});
		this.loadData();
	}
		
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	loadData(){
		try{
			this.setState({
				dataView: [],
				dataList: [],
				showLoader: true,
			});
			axios.get(Api.Url+'v1/customers?api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						customers: res['data'].data,
					});
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleCustomerChange(e){
		this.setState({selectedCustomer:e});
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		try{
			
			if(this.state.selectedCustomer.length<1)
			{
				message.error('Select Customer');
				return;
			}
			
			this.setState({showLoader: true});
			axios.post(Api.Url+'v1/collection/bycustomer', $("#frmPaymentSearch_cus").serialize()).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						dataList: res['data'].data,
						dataView: res['data'].data,
					});
				}
				else{
				message.error(res['data'].message || 'Error');
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){ 
			this.setState({showLoader: false});
		}
	}
	
	getFieldValue(field){
		try{
			var d = this.state.dataView;
			return d[0][field];
		}
		catch(error){ }
	}
	
	calculateTotal(fieldName){
		try{
			var d = this.state.dataView;
			var total = 0;
			d.map((item,i)=>{
				total = parseFloat(total) + parseFloat(item[fieldName]);
			});
			return parseFloat(total).toFixed(2);
		}
		catch(er){
			
		}
	}
	
	getAvg(field){
		try{
			var total = this.calculateTotal(field);
			var size = Object.keys(this.state.dataView).length;
			
			var avg = parseFloat(total) / parseFloat(size);
			
			return parseFloat(avg).toFixed(2);
		}
		catch(error){ }
	}
	
	printDocument() {
		var content = document.getElementById("label_print");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}
	
	onInputChange(e){
		this.setState({
			[e.target.name]: e.target.value,
		});
	}
	
	getTotalAdvance(){
		try{
			var t = (parseFloat(this.state.i__advance) + parseFloat(this.state.i__add)).toFixed(0);
			//this.setState({i__totalAdvance: t});
			return t;
		}
		catch(error){ }
	}
	
	getBalanceinAdvance(){
		try{
			var t = (parseFloat(this.state.i__advance) + parseFloat(this.state.i__add)).toFixed(0);
			var s = (parseFloat(this.state.i__currentDeduction) + parseFloat(this.state.i__lastPaid)).toFixed(0);
			var m = (parseFloat(t) - parseFloat(s));
			return m.toFixed(0);
		}
		catch(error){ }
	}
	
	getCashInHand(){
		try{
			var t = this.calculateTotal('total');
			var s = (parseFloat(t) - parseFloat(this.state.i__currentDeduction)).toFixed(2);
			
			return parseFloat(s).toFixed(2);
		}
		catch(error){ console.log(error);}
	}
	
	handleReset(){
		this.setState({
			dataList: [],
			dataView: [],
		});
	}
	
	render(){

		return(
		<div className="container" >
			<div data-aos="fade" >
				<Spin spinning={this.state.showLoader} >
				
				<div  style={{display: Object.keys(this.state.dataList).length > 0 ? 'none' : ''}}  >
				<form
					action="" 
					method="post"
					encType="multipart/form-data"
					id="frmPaymentSearch_cus"
					onSubmit={this.handleFormSubmit} 
				>
				
				<input type="hidden" name="api" value={this.context.state.api} />
				<input type="hidden" name="i__customer" value={this.state.selectedCustomer} />
				
				<Row>
					<Col md={4} >
						<label className="font-13" >Customer</label>
						 <Select
							  showSearch
							  style={{ width: 180 }}
							  placeholder="Select a Customer"
							  optionFilterProp="children"
							  onChange={this.handleCustomerChange}
							  style={{width: '100%'}}
							  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
							>
							  {this.state.customers.map((item) => (
								<Option key={item.id} value={item.id}>{item.customer_name+" ("+item.customer_code+")"}</Option>
							  ))}
							</Select>
					</Col>
					<Col md={3} >
						<label className="font-13" >From Date</label>
						<Form.Control
							type="date"
							name="i__from"
							id="i__from"
							size="sm"
							max={momentDate((new Date()),'YYYY-MM-DD')}
							required
						/>
					</Col>
					<Col md={3} >
						<label className="font-13" >To Date</label>
						<Form.Control
							type="date"
							name="i__to"
							id="i__to"
							size="sm"
							max={momentDate((new Date()),'YYYY-MM-DD')}
							required
						/>
					</Col>
					<Col md={2} >
						<Button
							type="submit"
							size="sm"
							block
							className="mt-30" 
						>
							VIEW
						</Button>
					</Col>
				</Row>
				</form>
				</div>
				
				
				{Object.keys(this.state.dataList).length > 0 ? <div data-aos="fade" > 
					<Row className="mt-10 mb-10" >
						<Col md={12} >
							<div className="text-center flex-center ">
								<Button
									type="button"
									size="sm"
									onClick={this.printDocument} 
								>
								PRINT
								</Button>
								&nbsp;
								<Button
									type="button"
									size="sm"
									variant="danger"
									onClick={this.handleReset} 
								>
								RESET
								</Button>
							</div>
						</Col>
					</Row>
				<div style={styles.paper} id="label_print"  >
					<table width="100%" align="center" >
						<tbody>
							<tr>
								<td align="center" colSpan="2" >
									<b>Varshini Milk & Milk Products - Karivalamvandanallur</b>
									<br />
									<b>Contact No : 9489906144</b>
								</td>
							</tr>
							<tr>
								<td colSpan="2"  align="center">
									<b>Milk Payment From - </b>
									{momentDate(document.getElementById("i__from").value,'DD.MM.YYYY')} to {momentDate(document.getElementById("i__to").value,'DD.MM.YYYY')}
								</td>
							</tr>
							<tr>
								<td>
									<b>NAME : {this.getFieldValue('customer_name')} - {this.getFieldValue('customer_address')}</b>
								</td>
								<td align="right" >
									<b>CODE: {this.getFieldValue('customer_code')}</b>
								</td>
							</tr>
							<tr>
								<td colSpan="2" align="center" style={{fontSize: '14px'}} >
									<table width="100%" >
										<tbody>
											<tr style={styles.trHeader}  >
												<td style={styles.trHeader} >Date</td>
												<td style={styles.trHeader}  >Shift</td>
												<td style={styles.trHeader}  align="right"  >Litters</td>
												<td style={styles.trHeader}  align="right"  >Fat (%)</td>
												<td style={styles.trHeader}  align="right"  >Snf (%) </td>
												<td style={styles.trHeader}  align="right"  >Avg.Rate</td>
												<td style={styles.trHeader}  align="right"  >Total</td>
											</tr>	
										{this.state.dataView.map((item,i)=>{
											return <tr key={i} >
												<td>{momentDate(item.entry_on,'DD.MM.YYYY')}</td>
												<td>{item.shift}</td>
												<td align="right"  >{item.litters}</td>
												<td align="right"  >{item.fat}</td>
												<td align="right"  >{item.snf}</td>
												<td align="right"  >{item.amount}</td>
												<td align="right" >{item.total}</td>
											</tr>
										})
										}
										<tr>
											<td colSpan="2"></td>
											<td align="right"  style={styles.tdSingleTopBr} >{this.calculateTotal('litters')}</td>
											<td align="right"  style={styles.tdSingleTopBr} >{this.getAvg('fat')}</td>
											<td align="right"  style={styles.tdSingleTopBr} >{this.getAvg('snf')}</td>
											<td align="right"  style={styles.tdSingleTopBr} >{this.getAvg('amount')}</td>
											<td align="right"  style={styles.tdSingleTopBr} >{this.calculateTotal('total')}</td>
										</tr>
										</tbody>
									</table>
								</td>
							</tr>	
							<tr>
								<td colSpan="2">
									<br />
									<table width="100%" align="center"  style={{fontSize: '14px'}} >
										<tbody>
											<tr style={styles.trHeader}  >
												<td colSpan="6" align="center" style={{padding: '5px'}} >
													Recovery Details
												</td>
											</tr>
											<tr>
												<td width="200" >Advance</td>
												<td width="100" >
													<input type="text" defaultValue="0" style={styles.txtNoBorder} name="i__advance" onChange={this.onInputChange} value={this.state.i__advance} onKeyPress={decimalKeyPress}  />
												</td>
												<td>Add</td>
												<td>
													<input type="text" defaultValue="0" style={styles.txtNoBorder} name="i__add" onChange={this.onInputChange}  value={this.state.i__add} onKeyPress={decimalKeyPress}  />
												</td>
												<td>Total Advance</td>
												<td>
													<input type="text" defaultValue="0" style={styles.txtNoBorder} name="i__totalAdvance" value={this.getTotalAdvance()} onKeyPress={decimalKeyPress}  />
												</td>
											</tr>											
											<tr>
												<td>Last Paid Amount</td>
												<td>
													<input type="text" defaultValue="0" style={styles.txtNoBorder} name="i__lastPaid" onChange={this.onInputChange} value={this.state.i__lastPaid} onKeyPress={decimalKeyPress}  />
												</td>
												<td colSpan="4"></td>
											</tr>
											<tr>
												<td>Current Week Deduction</td>
												<td>
													<input type="text" defaultValue="0" style={styles.txtNoBorder} name="i__currentDeduction" onChange={this.onInputChange} value={this.state.i__currentDeduction} onKeyPress={decimalKeyPress}  />
												</td>
												<td colSpan="4"></td>
											</tr>
											<tr>
												<td>Balance in Advance</td>
												<td>
													<input type="text" defaultValue="0" style={styles.txtNoBorder} name="i__cashInHand" value={this.getBalanceinAdvance()} onKeyPress={decimalKeyPress} />
												</td>
												<td colSpan="2"></td>
												<td colSpan="">Cash In Hand</td>
												<td>{this.getCashInHand()}</td>
											</tr>
											
										</tbody>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
				</div> 
				</div> : null}
				
				</Spin>
			</div>	
			</div>
		);
	}
	
}
export default NewPayment;
